import React from 'react';
import { Box, Stack } from '@mui/material';
import CharacterCounter from './CharacterCounter';
import BasicButton from '../button/BasicButton';
import CustomTextareaAutosize from './CustomTextareaAutosize';
import theme from '../../theme';

const CommentEditForm = ({
  editContent,
  setEditContent,
  onSubmit,
  onCancel,
  maxLength = 5000,
  placeholder = '내용을 입력해주세요.',
  submitText = '수정',
  cancelText = '취소',
}) => {
  const handleSubmit = (e) => {
    e.preventDefault();
    if (!editContent.trim()) return;
    onSubmit(e);
  };

  return (
    <Box component="form" onSubmit={handleSubmit} mb={2}>
      <Stack spacing={1}>
        <CustomTextareaAutosize
          minRows={3}
          placeholder={placeholder}
          value={editContent}
          onChange={(e) => setEditContent(e.target.value)}
          maxLength={maxLength}
        />
        <Stack
          direction={{ xs: 'column', md: 'row' }}
          justifyContent="space-between"
          alignItems="center"
          spacing={2}
        >
          <Box
            sx={{
              width: { xs: '100%', md: 'auto' },
              display: 'flex',
              justifyContent: { xs: 'flex-end', md: 'flex-start' },
            }}
          >
            <CharacterCounter currentLength={editContent?.length || 0} maxLength={maxLength} />
          </Box>
          <Box display="flex" gap={1} width={{ xs: '100%', md: 'auto' }}>
            <BasicButton
              variant="outlined"
              onClick={onCancel}
              sx={{
                width: { xs: '100%', md: 'auto' },
                minWidth: { md: '70px', lg: '58px' },
                height: { xs: '40px', md: '40px', lg: '30px' },
                padding: '8px 16px',
                typography: 'body3',
                fontWeight: 'medium',
              }}
            >
              {cancelText}
            </BasicButton>
            <BasicButton
              variant="contained"
              type="submit"
              disabled={!editContent.trim()}
              sx={{
                width: { xs: '100%', md: 'auto' },
                minWidth: { md: '70px', lg: '58px' },
                height: { xs: '40px', md: '40px', lg: '30px' },
                padding: '8px 16px',
                typography: 'body3',
                fontWeight: 'medium',
                color: theme.palette.primary.contrastText,
              }}
            >
              {submitText}
            </BasicButton>
          </Box>
        </Stack>
      </Stack>
    </Box>
  );
};

export default CommentEditForm;
